import api from './api';
import type { Event, Order, StorefrontResponse, CheckoutPayload, CheckoutResponse, PaymentCallbackResponse } from '@types';

export interface EventFilters {
  search?: string;
  category?: string;
  date_from?: string;
  date_to?: string;
  upcoming_only?: string;
  page?: number;
  per_page?: number;
}

export interface EventsListResponse {
  data: Event[];
  meta: {
    currentPage: number;
    lastPage: number;
    perPage: number;
    total: number;
  };
}

export interface CouponValidationResponse {
  data: {
    code: string;
    type: 'percentage' | 'fixed_amount';
    value: number;
    maxDiscount?: number;
    minOrderAmount: number;
  } | null;
  message: string;
}

export const publicApi = {
  getStorefront: () =>
    api.get<StorefrontResponse>('/public/storefront'),

  getEvents: (params?: EventFilters) =>
    api.get<EventsListResponse>('/public/events', params),

  getCategories: () =>
    api.get<{ data: string[] }>('/public/events/categories'),

  getEventBySlug: (slug: string) =>
    api.get<{ data: Event }>(`/public/events/${slug}`),

  validateCoupon: (code: string, eventId: number) =>
    api.post<CouponValidationResponse>('/public/coupons/validate', { code, event_id: eventId }),

  createCheckout: (data: CheckoutPayload) =>
    api.post<CheckoutResponse>('/public/checkout', data),

  getOrderStatus: (ref: string) =>
    api.get<{ data: Order }>(`/public/orders/${ref}`),

  getPaymentCallback: (ref: string, tapId: string) =>
    api.get<PaymentCallbackResponse>(`/public/orders/${ref}/callback`, { tap_id: tapId }),
};
